function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M44.972 41.277c10.206 0 18.48-8.29 18.48-18.516 0-10.226-8.274-18.516-18.48-18.516-10.206 0-18.48 8.29-18.48 18.516 0 10.226 8.274 18.516 18.48 18.516zM121.701 41.235c10.205 0 18.479-8.29 18.479-18.516 0-10.226-8.274-18.516-18.479-18.516-10.206 0-18.48 8.29-18.48 18.516 0 10.226 8.274 18.516 18.48 18.516z",
  stroke: "#28ABE2",
  strokeWidth: 4,
  strokeMiterlimit: 10
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M25.003 81.672v66.287a5.703 5.703 0 01-1.803 3.876 5.68 5.68 0 01-3.986 1.526h-8.076a5.682 5.682 0 01-4.021-1.564 5.702 5.702 0 01-1.768-3.943V84.446c0-16.666 7.048-28.247 31.044-29.865h22.716c22.948 1.891 36.603 13.346 36.603 29.802v26.502l-.147 32.345v94.577a5.85 5.85 0 003.74 5.415c.727.28 1.502.411 2.28.385h11.767c3.44 0 4.3-2.585 4.3-5.8v-83.501a4.017 4.017 0 014.195-3.867h5.391a4.012 4.012 0 012.904 1.056 4.021 4.021 0 011.291 2.811l14.683 83.501a6.043 6.043 0 001.94 4.214 6.017 6.017 0 004.353 1.586h8.893a6.017 6.017 0 005.744-3.499c.333-.723.52-1.505.549-2.301l-14.683-84.068",
  stroke: "#28ABE2",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.878 153.844l-8.055 46.09-6.628 37.831a5.848 5.848 0 003.74 5.415c.727.28 1.502.411 2.28.385h11.768c3.44 0 4.3-2.585 4.3-5.8l6.02-34.237 8.662-49.264a4.018 4.018 0 012.638-3.631 4.009 4.009 0 011.557-.236h5.307a4.009 4.009 0 014.195 3.867v83.585a6.04 6.04 0 003.958 5.444c.748.272 1.541.393 2.335.357h8.894a6.027 6.027 0 002.335-.357 6.037 6.037 0 003.408-3.143c.333-.723.52-1.505.55-2.301V88.209l19.821 17.864",
  stroke: "#28ABE2",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M29.974 35.371l-5.328.673a5.742 5.742 0 00-3.942 1.752 5.765 5.765 0 00-1.616 4.007v9.836c0 .847.336 1.66.934 2.259.598.599 1.409.935 2.254.935h15.501M147.291 79.801v67.675a5.66 5.66 0 001.755 3.913 5.638 5.638 0 003.992 1.551h6.628a5.634 5.634 0 003.992-1.551 5.66 5.66 0 001.756-3.913V84.698c0-16.372-7.342-27.763-30.163-29.655h-20.703a9.487 9.487 0 01-3.566-.693c-5.496-2.249-22.108-16.351-52.166-17.486",
  stroke: "#28ABE2",
  strokeWidth: 3.66,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgIconBuddy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 248,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default SvgIconBuddy;